<template>
  <div class="container-fluid">
    <!-- <BnpGrid v-if="render" :hasRowNum="true" :propsColumn="Columns" :propsRows="rows" :action="true">
      <template slot="action-slot" slot-scope="props">
        <a v-if="$route.name == 'EducationManage'" @click="deleteQ(props.props.id)" class="mx-2 hover-danger"><i class="fad fa-trash"></i></a>
        <a v-if="$route.name == 'EducationManage'" @click="editMode(props.props)" class="mx-2 hover-warning"><i class="fad fa-pen"></i></a>
        <a @click="download(props.props)" class="mx-2 hover-success"><i class="fad fa-download"></i></a>
      </template>
      <template slot="filename" slot-scope="props">
        {{ props.props.filename.replace(props.props.id, '').replace(/\.[^/.]+$/, '') }}
      </template>
    </BnpGrid> -->
    <div class="col-12 mt-2">
      <div class="row">
        <div class="col-12 mt-2 p-2 Rounded border">
          <div class="row m-1">
            <div class="col-1 font-weight-bold">ردیف</div>
            <div class="col-3 font-weight-bold">شماره فایل</div>
            <div class="font-weight-bold" :class="$session.get('Menu').filter((x) => x.RouteName == 'ViewCustomerFiles')[0].isMojaz ? 'col-3' : 'col-6'">{{ label }}</div>
            <div class="col-3 font-weight-bold" v-if="$session.get('Menu').filter((x) => x.RouteName == 'ViewCustomerFiles')[0].isMojaz">نام مشتری</div>
            <div class="col-2 font-weight-bold">عملیات</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-2">
      <div class="row">
        <div class="col-12 mt-2 p-4 Rounded border" v-for="(item, index) in rows" :key="index">
          <div class="row m-1">
            <div class="col-1">{{ index + 1 }}</div>
            <div class="col-3">{{ item.id }}</div>
            <div :class="$session.get('Menu').filter((x) => x.RouteName == 'ViewCustomerFiles')[0].isMojaz ? 'col-3' : 'col-6'">{{ item.parentFormId }}</div>
            <div class="col-3" v-if="$session.get('Menu').filter((x) => x.RouteName == 'ViewCustomerFiles')[0].isMojaz">{{ item.customerName }}</div>

            <div class="col-2">
              <div v-if="$route.name == 'FileManage' || $route.name == 'EducationManage'">
                <a @click="deleteQ(item.id)" class="mx-2 hover-danger"><i class="fad fa-trash"></i></a>
                <a @click="editMode(item)" class="mx-2 hover-warning"><i class="fad fa-pen"></i></a>
                <span v-if="item.customerName == ''">
                  <a EducationTable target="_blank" :href="$cookies.get('URL') + item.filepath" class="mx-2 hover-success"><i class="fad fa-download"></i></a>
                </span>
                <span v-else>
                  <a v-if="item.tblUserGrpIdInsert == $session.get('UserInfo').tblUserGrpId" EducationTable target="_blank" :href="$cookies.get('URL') + item.filepath" class="mx-2 hover-success"><i class="fad fa-download"></i></a>
                </span>
              </div>
              <div v-else>
                <a target="_blank" :href="$cookies.get('URL') + item.filepath" class="mx-2 hover-success"><i class="fad fa-download"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      rows: [],
      render: true,
      Columns: [
        { id: 2416, name: 'id', visibility: true, label: 'شماره فایل' },
        { id: 2416, name: 'parentFormId', visibility: true, label: this.label },
        { id: 2416, name: 'parentFormId', visibility: true, label: this.label },
      ],
    }
  },
  created() {
    if (this.FromMyFiles) {
      this.GetMyFiles()
    } else this.GetTable()
  },
  props: ['tablename', 'label', 'FromMyFiles'],
  components: { BnpGrid },
  methods: {
    GetTable() {
      var DataAxiosGet = {
        Action: this.$session.get('Menu').filter((x) => x.RouteName == 'ViewCustomerFiles')[0].isMojaz ? 'CrmFile/GetFileBytableNamewithCustomer' : 'CrmFile/GetFileBytableName',
        Method: 'POSt',
        ArryfildValue: {
          tableName: this.tablename,
        },
      }
      this.$PostData(DataAxiosGet)
        .then((Result) => {
          this.rows = Result.data
        })
        .finally(() => {
          this.render = false
          this.$nextTick(() => {
            this.render = true
          })
        })
    },
    deleteEd(id) {
      var DataAxiosDelete = {
        Action: 'CrmFile/DeleteFile',
        Method: 'POSt',
        ArryfildValue: {
          Id: id,
        },
      }
      this.$PostData(DataAxiosDelete).then((result) => {
        if (result.status) {
          this.$mySweetDefaultTost('عملیات موفق', 'حذف با موفقیت انجام شد', 'success', 1000)
          this.GetTable()
        }
      })
    },
    deleteQ(data) {
      this.$SweetQustion('هشدار', 'ایا از حذف ادرس اطمینان دارید؟', 'info', 'بله', 'انصراف', data, this.deleteEd, this.cancel)
    },
    editMode(data) {
      this.$emit('edit', data)
    },
    download(data) {
      console.warn(data)
      var DataAxios = {
        Action: 'Download',
        Method: 'Post',
        ArryfildValue: {
          FilePath: data.filepath,
          FileName: data.filename,
          Number: data.parentFormId,
        },
      }
      this.$PostData(DataAxios).then((response) => {
        var fileLink = document.createElement('a')
        fileLink.href = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + response.data.fileContents
        fileLink.setAttribute('download', response.data.fileDownloadName)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    GetMyFiles() {
      var DataAxiosGet = {
        Action: 'CrmFile/GetFileByCustomerId',
        Method: 'POSt',
        ArryfildValue: {
          Id: this.$session.get('CustomerInfo').Id,
        },
      }
      this.$PostData(DataAxiosGet).then((Result) => {
        this.rows = Result.data
        // console.log(Result)
      })
    },
  },
}
</script>
<style scoped>
.Rounded {
  border-radius: 35px !important;
  background: var(--sidebar-action-bg) !important;
  -webkit-box-shadow: 5px 5px 13px 3px rgba(0, 0, 0, 0.06);
  box-shadow: 5px 5px 13px 3px rgba(0, 0, 0, 0.06);
}
</style>
